import { render, staticRenderFns } from "./SkeletonLoaderItem.vue?vue&type=template&id=22b57981&scoped=true&"
import script from "./SkeletonLoaderItem.vue?vue&type=script&lang=ts&"
export * from "./SkeletonLoaderItem.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonLoaderItem.vue?vue&type=style&index=0&id=22b57981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b57981",
  null
  
)

export default component.exports